module.exports = __webpack_public_path__ + "static/media/image_24.8dbec53f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_174/img/image_24.png
// module id = 452
// module chunks = 0